import AffiliationForm from './AffiliationForm';
import AffiliationTable from './AffiliationTable';
import axios from '../../libs/axios_csrf';
import React from 'react';
import { injectIntl } from 'react-intl';
import { inject } from 'mobx-react';
import { Row, Col, Panel } from 'react-bootstrap';
import BlockUi from '../common_components/BlockUi'

@inject('affiliationStore')
@inject('isPremium')
@injectIntl
export default class Affilation extends React.Component {
  constructor(props) {
    super(props);
  }

  isBlockUi() {
    const {
      isPremium = false,
      affiliationStore = { memberships: [] }
    } = this.props

    return (
      !isPremium &&
      affiliationStore.memberships.length >= 3
    )
  }

  render() {
    return (
      <Row className="show-grid">
        <Col md={6}>
          <Panel className="panel-fixed-height">
            <div>
              <h4 className="bold">
                {this.props.intl.formatMessage({ id: 'send_invitations' })}
              </h4>
              <BlockUi blocking={this.isBlockUi()}>
                <AffiliationForm />
              </BlockUi>
            </div>
          </Panel>
        </Col>

        <Col md={6}>
          <Panel className="panel-fixed-height">
            <div>
              <h4 className="bold">
                {this.props.intl.formatMessage({ id: 'recently_sent' })}
              </h4>
              <AffiliationTable />
            </div>
          </Panel>
        </Col>
      </Row>
    );
  }
}
